<template>
  <div class="body container-fluid">
    <p>Page not found. Go to <router-link to="/"> Home</router-link></p>
  </div>
</template>
